var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "notification-preferences-page" }, [
    _c("p", [
      _vm._v(
        "Shopify may still contact me about order information such as order confirmations, when my order ships, and when orders are delivered."
      )
    ]),
    _c("p", { attrs: { "aria-live": "alert" } }, [
      _vm.subscribed
        ? _c("b", [
            _vm._v(
              "You are currently subscribed to Ratio Food news and offers by email."
            )
          ])
        : _vm._e(),
      !_vm.subscribed
        ? _c("b", [
            _vm._v(
              "You are not currently subscribed to Ratio Food news and offers by email."
            )
          ])
        : _vm._e()
    ]),
    !_vm.subscribed
      ? _c(
          "form",
          {
            directives: [
              {
                name: "disable-all",
                rawName: "v-disable-all",
                value: !_vm.loaded,
                expression: "!loaded"
              }
            ],
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.subscribe.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("label", { staticClass: "checkbox-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.subscribe_checkbox,
                      expression: "subscribe_checkbox"
                    }
                  ],
                  attrs: {
                    type: "checkbox",
                    name: "over18",
                    id: "user_over18",
                    required: ""
                  },
                  domProps: {
                    checked: Array.isArray(_vm.subscribe_checkbox)
                      ? _vm._i(_vm.subscribe_checkbox, null) > -1
                      : _vm.subscribe_checkbox
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.subscribe_checkbox,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.subscribe_checkbox = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.subscribe_checkbox = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.subscribe_checkbox = $$c
                      }
                    }
                  }
                }),
                _c(
                  "span",
                  {
                    staticClass:
                      "checkbox-input__checkbox checkbox--toggle-all toggle-all-true"
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "icon",
                        attrs: {
                          viewBox: "0 0 16 14",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "currentColor"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M4.69 10.198 1.664 7.044 0 8.778l3.993 4.162.005-.005.729.76L16 1.945 14.304.177z",
                            fill: "currentColor"
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._m(0)
              ])
            ]),
            _vm._m(1)
          ]
        )
      : _c(
          "form",
          {
            directives: [
              {
                name: "disable-all",
                rawName: "v-disable-all",
                value: !_vm.loaded,
                expression: "!loaded"
              }
            ],
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.unsubscribe.apply(null, arguments)
              }
            }
          },
          [_vm._m(2)]
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "checkbox-input__label-text" }, [
      _vm._v("By signing up, you are accepting our "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://www.generalmills.com/privacy-security/us-english-privacy-policy",
            target: "_blank"
          }
        },
        [_vm._v("Privacy Policy")]
      ),
      _vm._v(" and agreeing that your information may be used across our "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.generalmills.com/food-we-make/brands",
            target: "_blank"
          }
        },
        [_vm._v("family of brands")]
      ),
      _vm._v(".")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c(
        "button",
        {
          staticClass: "btn btn--primary",
          attrs: { type: "submit", id: "account-subscription" }
        },
        [_vm._v("Subscribe")]
      )
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c(
        "button",
        {
          staticClass: "btn btn--primary",
          attrs: { type: "submit", id: "account-subscription" }
        },
        [_vm._v("UnSubscribe")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }